

























































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import Tab from "@/zh-website/src/components/website/TabChange.vue";
import { DigitalService } from "@/zh-website/src/views/Enterprise/service/DigitalService";
import { CommonService } from "@/zh-website/src/views/Enterprise/service/CommonService";
@Component({
  components: {
    Tab
  }
})
export default class DigitalClassify extends Vue {
  bannerStyle = ""; //banner背景图
  tabList: any[] = [];
  solutionList: any[] = [];
  classifyName = "";
  // 当前页面的dictCode0037006
  dictCode = "0037005";
  // 成功案例
  moreList = [];
  plansId = [];
  @Watch("$route", { immediate: true })
  onRouteChange(route) {
    // this.classifyName = route.params.classifyName
    this.getSolution();
    this.getAllClassification();
  }
  mounted() {
    this.getSolution();
    this.getAllClassification();
  }
  getSolution() {
    this.tabList.length = 0;
    this.solutionList.length = 0;
    DigitalService.getSolutionList({
      classificationId: this.$route.params.id
    }).then((res: any) => {
      this.tabList = [];
      this.solutionList = [];
      res.data.list.forEach((item: any, index) => {
        this.tabList.push({
          id: item.id,
          name: item.title
        });
        this.solutionList.push({
          id: item.id,
          name: item.title,
          des: item.subtitle,
          resourceUrl: item.resourceUrl,
          isShowSuccessCase: item.isShowSuccessCase
        });
      });
    });
  }
  getAllClassification() {
    CommonService.getAllClassification({}).then((res: any) => {
      res.data[2].child.forEach((item: any) => {
        if (item.id == this.$route.params.id) {
          this.classifyName = item.name;
          this.bannerStyle = `background-image:url(${item.resourceUrl})`;
        }
      });
    });
  }
  // 获取解决方案
  async _getCase() {
    //
  }
  // 获取成功案例
  async _getMoreList(num) {
    //
  }
  // 获取解决方案下的成功案例
  async _getList(val) {
    //
  }
  // 跳转成功案例
  _toLink(e) {
    window.sessionStorage.setItem("caseCode", JSON.stringify(this.dictCode));
    this.$router.push("/enterprise/digital/case/" + e);
  }
  // 跳转解决方案页
  _tolink2(e) {
    window.sessionStorage.setItem("caseCode", JSON.stringify(this.dictCode));
    this.$router.push("/enterprise/digital/solution/" + e);
  }
}
